import React from 'react';

import Button from '@components/Button';

import marketingModalStyles from '../Layout/styles.module.scss';

const CustomUrlModalBody = ({ buttonText, customUrl, disclosure, trackingProps }) => {
  return (
    <div>
      <div className={marketingModalStyles.offerAction}>
        <Button
          href={customUrl}
          trackingProps={{ ...trackingProps, name: 'custom_url' }}
          trackClick
          variant="primary"
          width="full"
        >
          {buttonText}
        </Button>
      </div>
      <div className={marketingModalStyles.disclosure}>{disclosure}</div>
    </div>
  );
};

export default CustomUrlModalBody;
